import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowFitBottomLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.655 1.499a.5.5 0 0 1 .5-.5h4.846v4.845h-1V2.705L2.706 10h5.311a.5.5 0 0 1 0 1H2.5A1.5 1.5 0 0 1 1 9.5V3.982a.5.5 0 0 1 1 0v5.312l7.295-7.295h-3.14a.5.5 0 0 1-.5-.5m4.846 4.346h.5a.5.5 0 0 1-1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomLeft12);
